(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-section"] && !Shopify.designMode) return;
  try {
    
if (window.location.hash && document.querySelector(window.location.hash)) {
  const selectedEl = document.querySelector(window.location.hash);
  selectedEl.setAttribute('open', true);
  window.scrollTo({
    top: selectedEl.getBoundingClientRect().top,
    behavior: 'smooth'
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["design-hub-nav"] && !Shopify.designMode) return;
  try {
    
  const hubNav = document.querySelector('#hub-nav');
  const hash = window.location.hash;
  const hubSections = document.querySelectorAll('.section-hub-content');

  const changeSections = (type = 'curtains') => {
    hubSections.forEach((section) => {
      if (!section.classList.contains(`section-hub-${type}`)) {
        section.classList.add('visually-hidden');
      } else {
        section.classList.remove('visually-hidden');
      }
    });
  };

  if (hash) {
    hubNav.value = hash.replace('#', '');
    window.scrollTo({ top: hubNav.offsetTop });
    changeSections(hash.replace('#', ''));
  } else {
    changeSections();
  }

  hubNav.addEventListener('change', function (e) {
    e.preventDefault();
    window.location.hash = e.currentTarget.value;
    changeSections(e.currentTarget.value);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const expandDetails = function () {
    if (window.matchMedia('(min-width: 768px)').matches) {
      const footerDetails = document.querySelector('.footer-menus').querySelectorAll('.menu-item details-collapse:not(.no-toggle) details');
      footerDetails.forEach(function (detail) {
        detail.setAttribute('open', '');
      });
      const footerContact = document.querySelector('.footer-contact').querySelectorAll('.text-block-contact details-collapse:not(.no-toggle) details');
      footerContact.forEach(function (detail) {
        detail.setAttribute('open', '');
      });
    } else {
      const footerDetails = document.querySelector('.footer-menus').querySelectorAll('.menu-item details-collapse:not(.no-toggle) details');
      footerDetails.forEach(function (detail) {
        detail.removeAttribute('open');
      });
      const footerContact = document.querySelector('.footer-contact').querySelectorAll('.text-block-contact details-collapse:not(.no-toggle) details');
      footerContact.forEach(function (detail) {
        detail.removeAttribute('open');
      });
    }
  };
  window.addEventListener('resize', expandDetails);
  expandDetails();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;

    if (document.body.classList.contains('template-page-curtain-calculator')) {
      this.preventReveal = true;
    }

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    this.checkInitialScrollPosition();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
      // Check initial scroll position after headerBounds are set
      this.checkInitialScrollPosition();
    });

    observer.observe(this.header);
  }

  checkInitialScrollPosition() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const offset = 90; 
    if (scrollTop > this.headerBounds.bottom - offset) {
      this.sticky();
    }
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const offset = 90;

    if (scrollTop > this.currentScrollTop) {
      if (scrollTop > this.headerBounds.bottom - offset) {
        requestAnimationFrame(this.sticky.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  sticky() {
    if (!this.header.classList.contains('shopify-section-header-sticky')) {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
    }
  }

  hide() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
  }

  reset() {
    this.header.classList.remove('shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-swatch-grid"]) return;
  try {
    
  const customFilters = document.querySelector('.custom-filters');
  if (window.matchMedia('(min-width: 40em)').matches && customFilters) {
    customFilters.querySelector('details').setAttribute('open', '');
    customFilters.querySelector('summary').classList.add('visually-hidden');
  }

  // function scrollTrigger(selector) {
  //   let els = document.querySelectorAll(selector);
  //   els = Array.from(els);
  //   els.forEach((el) => {
  //     addObserver(el);
  //   });
  // }
  // function addObserver(el) {
  //   let observer = new IntersectionObserver((entries, observer) => {
  //     entries.forEach((entry) => {
  //       if (entry.isIntersecting) {
  //         entry.target.classList.add('active');
  //         observer.unobserve(entry.target);
  //       }
  //     });
  //   });
  //   observer.observe(el);
  // }
  // scrollTrigger('.collection');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-swatch-new"] && !Shopify.designMode) return;
  try {
    
  const customFilters = document.querySelector('.custom-filters');
  if (window.matchMedia('(min-width: 40em)').matches && customFilters) {
    customFilters.querySelector('details').setAttribute('open', '');
    customFilters.querySelector('summary').classList.add('visually-hidden');
  }

  // function scrollTrigger(selector) {
  //   let els = document.querySelectorAll(selector);
  //   els = Array.from(els);
  //   els.forEach((el) => {
  //     addObserver(el);
  //   });
  // }
  // function addObserver(el) {
  //   let observer = new IntersectionObserver((entries, observer) => {
  //     entries.forEach((entry) => {
  //       if (entry.isIntersecting) {
  //         entry.target.classList.add('active');
  //         observer.unobserve(entry.target);
  //       }
  //     });
  //   });
  //   observer.observe(el);
  // }
  // scrollTrigger('.collection');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-multi-collections"] && !Shopify.designMode) return;
  try {
    
  const customFilters = document.querySelector('.custom-filters');
  if (window.matchMedia('(min-width: 40em)').matches && customFilters) {
    customFilters.querySelector('details').setAttribute('open', '');
    customFilters.querySelector('summary').classList.add('visually-hidden');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      if (!this.classList.contains('curated-related-products')) {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
            })
            .catch((e) => {
              console.error(e);
            });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-instructable"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});


  } catch(e) { console.error(e); }
})();
})();
